<template>
  <div
    ref="panelGroup"
    class="cf-node-properties__panel-group"
  >
    <legend class="cf-node-properties__legend">
      <span v-t="'ROUTER_ROUTES'" />
    </legend>
    <button
      type="button"
      class="btn btn-success btn-sm m-b-10"
      @click.stop.prevent="addRoute"
    >
      <i class="fa fa-plus" />
      <span v-t="'ROUTER_ADD_ROUTE'" />
    </button>

    <div
      v-if="orderedRoutes.length == 0"
      class="text-center"
    >
      <span v-t="'ROUTER_NO_ROUTES'" />
    </div>
    <Draggable
      v-model="orderedRoutes"
      filter=".cf-node-properties__panel--open"
      :prevent-on-filter="false"
    >
      <RoutePanel 
        v-for="(route, index) in orderedRoutes"
        :key="route.id"
        :index="index+1"
        :route.sync="route"
        :open-options="true"
        :has-filter="true"
        :sortable="true"
        :focus-element="focusElement(route)"
      >
        <RouteFilter
          :filter-criteria.sync="route.criteria"
          @update:filterCriteria="onRouteChange"
        />
      </RoutePanel>
    </Draggable>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Draggable from 'vuedraggable';

import { getTreeSaveObject } from '../../../../helpers/save';
import messages from '../../../../locales';
import RoutePanel from '../Form/RoutePanel';
import RouteFilter from './RouteFilter';
import nodePropsMixin from '@/modules/ivrs/mixins/nodePropsMixin';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'RouterNodeProps',
  components: {
    RoutePanel,
    RouteFilter,
    Draggable
  },

  mixins: [nodePropsMixin],

  props: {
    routes: {
      type: Array,
      default() {
        return [];
      }
    },
    scene: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      orderedRoutesList: cloneDeep(this.routes),
    };
  },
  computed: {
    ...mapGetters('callFlows', [
      'callFlowTreeId'
    ]),

    orderedRoutes: {
      get() {
        return this.orderedRoutesList;
      },

      set(value) {
        this.orderedRoutesList = value;
        this.$emit('update:routes', this.orderedRoutesList);
      }
    }
  },
  watch: {
    routes(newValue) {
      this.orderedRoutesList = cloneDeep(newValue);
    }
  },
  async created() {
    this.getAvailableTags({
      tree: getTreeSaveObject(this.callFlowTreeId,this.scene), 
      parentNodeId: this.node.id
    });

    await this.loadBulkTags();
  },
  methods: {
    ...mapActions('callFlows', ['getAvailableTags', 'loadBulkTags']),

    onRouteChange() {
      this.$emit('update:routes', this.orderedRoutesList);
    },

    addRoute(event) {
      this.$emit('showContextMenu', event, {
        node: this.node,
        slotNumber: 0,
        isOnFailure: false,
      });
    },
    focusElement(route) {
      return this.node.selectedLinkId === route.id;
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>